import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

interface UseAddPendingInviteParams {
  userEmail: string;
}

export const useAddPendingInvite = ({ matterId }: { matterId: string }) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation<void, Error, UseAddPendingInviteParams>(
    async ({ userEmail }: UseAddPendingInviteParams) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.POST,
        data: { userEmail },
      });

      const response = await fetch(`${APIBaseChronos}/api/matters/${matterId}/pending-invites`, fetchConfig);

      if (!response.ok) {
        throw new Error('Failed to add pending invite');
      }
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [QueryEntity.PendingInvites, { matterId }] });
      },
      onError: () => {
        toast.error('Failed to add pending invite. Please try again.');
      },
    },
  );
};
